import { render, staticRenderFns } from "./AddVoice.vue?vue&type=template&id=14c35c28&scoped=true&"
import script from "./AddVoice.vue?vue&type=script&lang=js&"
export * from "./AddVoice.vue?vue&type=script&lang=js&"
import style0 from "./AddVoice.vue?vue&type=style&index=0&id=14c35c28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c35c28",
  null
  
)

export default component.exports